"use client"

import { useEffect, useState } from "react"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { sendGTMEvent } from "@next/third-parties/google"

import { generatePageTypeTrackingData } from "@/lib/gtmTrackingHelper"
import type { CommonPageContext } from "@/lib/tracking/tracking"

export interface PageTrackingClientProps {
  type: string
  sbLocale?: string
}

const PageTrackingClient = (props: PageTrackingClientProps) => {
  const [tracked, setTracked] = useState(false)
  const [commonPageContext, setCommonPageContext] = useState<CommonPageContext | undefined>()
  const { usedGuidedSelling, guidedSellingCampaign } = useUbStorefrontState()

  useEffect(() => {
    if (commonPageContext) {
      return
    }

    const controller = new AbortController()
    const contextUrl = props.sbLocale
      ? `/api/storefront/context?sbLocale=${encodeURIComponent(props.sbLocale)}`
      : "/api/storefront/context"

    fetch(contextUrl, {
      cache: "no-store",
      signal: controller.signal,
    })
      .then((response) => (response.ok ? response.json() : undefined))
      .then((context: CommonPageContext | undefined) => {
        if (context) {
          setCommonPageContext(context)
        }
      })
      .catch((error) => {
        if (error?.name !== "AbortError") {
          console.error("Could not load storefront context for page tracking", error)
        }
      })

    return () => controller.abort()
  }, [commonPageContext, props.sbLocale])

  useEffect(() => {
    if (!tracked && commonPageContext) {
      sendGTMEvent(
        generatePageTypeTrackingData(
          commonPageContext.isAnonymous,
          commonPageContext.isB2B,
          props.type,
          commonPageContext.userId,
          undefined,
          undefined,
          usedGuidedSelling,
          guidedSellingCampaign
        )
      )
      setTracked(true)
    }
  }, [tracked, commonPageContext, props.type, usedGuidedSelling, guidedSellingCampaign])

  return <span className={"hidden"}>CategoryBrandsSectionTrackingClient</span>
}
export default PageTrackingClient
